import "../Custom.css"

const ServicesPage = ({ prop }) => {
  const { leftColumnData, rightColumnData } = prop

  return (
    <div className="container pb-5">
      <div className="row">
        {/* 1st column */}
        <div className="col-12 col-md-6">
          <div className="row p-2 animated animatedFadeInUp fadeInUp animation-delay3">
            <h1
              className="fw-bold d-none d-md-block text-secondary text-black text-center"
              style={{ fontSize: "60px" }}
            >
              Our expertise<span className="text-warning">.</span>
            </h1>
            <h1
              className="fw-bold d-block d-md-none text-secondary text-black text-center"
              style={{ fontSize: "40px" }}
            >
              Our expertise<span className="text-warning">.</span>
            </h1>
          </div>

          {leftColumnData.map((data, index) => (
            <>
              <div className="row p-5 animated animatedFadeInUp fadeInUp animation-delay4">
                <img
                  src={data.imgPath}
                  className="transform"
                  alt={data.title}
                  height="auto"
                  width="auto"
                />
              </div>
              <div className="row px-5 text-center animated animatedFadeInUp fadeInUp animation-delay5">
                <p className="fw-bold text-black border-bottom border-warning">
                  {data.title}
                </p>
                <p style={{ color: "#495057" }}>
                  <small>{data.desc}</small>
                </p>
              </div>
              {/* {data.projects && (
                <div className="row px-5 animated animatedFadeInUp fadeInUp animation-delay6">
                  <p style={{ color: "#495057" }}>
                    <small>
                      <span className="fw-bold text-secondary">
                        Upcoming Projects <br />
                      </span>
                      <ul>
                        {data.projects.map((item, index) => (
                          <li>{item.name}</li>
                        ))}
                      </ul>
                    </small>
                  </p>
                </div>
              )} */}
            </>
          ))}
        </div>

        {/* 2nd column */}
        <div className="col-12 col-md-6">
          {rightColumnData.map((data, index) => (
            <>
              <div className="row p-5 animated animatedFadeInUp fadeInUp animation-delay5">
                <img
                  src={data.imgPath}
                  className="transform"
                  alt={data.title}
                  height="auto"
                  width="auto"
                />
              </div>
              <div className="row px-5 text-center animated animatedFadeInUp fadeInUp animation-delay6">
                <p className="fw-bold text-black border-bottom border-warning">
                  {data.title}
                </p>
                <p style={{ color: "#495057" }}>
                  <small>{data.desc}</small>
                </p>
              </div>
              {/* {data.projects && (
                <div className="row px-5 animated animatedFadeInUp fadeInUp animation-delay6">
                  <p style={{ color: "#495057" }}>
                    <small>
                      <span className="fw-bold text-secondary">
                        Upcoming Projects <br />
                      </span>
                      <ul>
                        {data.projects.map((item, index) => (
                          <li>{item.name}</li>
                        ))}
                      </ul>
                    </small>
                  </p>
                </div>
              )} */}
            </>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ServicesPage
